import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { UserStorageService } from '@app/core/services/user-storage.service';
import { User } from '@app/core/models/user';

@Component({
  selector: 'app-inline-installation-info',
  templateUrl: './inline-installation-info.component.html',
  styleUrls: ['./inline-installation-info.component.scss']
})
export class InlineInstallationInfoComponent implements OnInit, OnDestroy {
  onSetCurrentUser$!: Observable<User>;
  currentUser?: User;
  isLoggedIn$!: Observable<boolean>;
  defaultInstallationName!: string;
  defaultInstallationDescription!: string;


  private _onSetCurrentUserSub!: Subscription;

  constructor(
    private userStorageService: UserStorageService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.defaultInstallationName = $localize `New installation`;
    this.defaultInstallationDescription = $localize `This is new installation`;

    this.currentUser = this.userStorageService.currentUser;
    this._onSetCurrentUserSub = this.authenticationService.onSetCurrentUser$.subscribe(data => {
      this.currentUser = data;
    });

    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
  }

  ngOnDestroy() {
    this._onSetCurrentUserSub.unsubscribe();
  }
}
